<template>
  <div class="open-menber">
    <div class="head"><img src="@/assets/images_member/20240302/bg.png" class="icon" alt=""></div>
    <div class="index">
      <div class="open-menber-bg">
        <div class="agency-per">
          <img :src="userInfo.headimgurl" @click="handleJump('INDEX')" class="per-head" alt="">
          <div class="per-con">
            <div class="name" @click="handleJump('INDEX')">{{ userInfo.nickname }}</div>
            <div class="tag" @click="handleJump('PAGECARD')">
              查看我的卡包
              <img src="@/assets/images_member/20240302/Group 1176.png" class="icon" alt="">
            </div>
          </div>
        </div>
        <div class="card-bag" @click="handleJump('couponlist')">
          <img src="@/assets/images_member/20240302/img(4).png" class="icon-bag" alt="">
          <div class="txt">我的优惠券</div>
        </div>
        <div class="flex-nav">
          <div class="nav-txt" :class="curItem === index + '' ? 'cur' : ''" v-for="(item, index) in details" :key="index"
            @click="handleClickItem(index)">{{ item.title }}</div>
        </div>
        <div class="flex-nav2" v-if="details[curItem] && details[curItem].key === 'join'">
          <div class="nav2-txt" :class="curItem2 === index + '' ? 'cur' : ''" v-for="(item, index) in details[curItem].lists"
            :key="index" @click="handleClickItem2(index)">{{ item.title }}</div>
        </div>
        <div class="flex-nav3" v-if="details[curItem] && details[curItem].key === 'ecology'">
          <div class="nav3-txt" :class="curItem3 === index + '' ? 'cur' : ''" v-for="(item, index) in details[curItem].lists"
            :key="index" @click="handleClickItem3(index)">{{ item.title }}</div>
        </div>
        <div class="flex-nav4" v-if="details[curItem] && details[curItem].key === 'ecology'">
          <div class="nav4-txt" :class="curItem4 === index + '' ? 'cur' : ''"
            v-for="(item, index) in details[curItem].lists[curItem3].lists" :key="index" @click="handleClickItem4(index)">{{
              item.title }}</div>
        </div>
        <div class="flex-nav4" v-if="details[curItem] && details[curItem].key === 'xinqiu'">
          <div class="nav4-txt" :class="curItem6 === index + '' ? 'cur' : ''"
            v-for="(item, index) in details[curItem].lists[curItem3].lists" :key="index" @click="handleClickItem6(index)">{{
              item.title }}</div>
        </div>
        <div class="div-con-xinqiu" v-if="details[curItem] && details[curItem].key === 'xinqiu'">
          <img :src="pageData.bg_img_path" class="img-bg" alt="" >
          <span class="bg-title">{{ pageData.title }}</span>
          <div class="txt1">{{ pageData.title }}<span class="x"></span><span class="desc">{{ pageData.desc1 }}</span></div>
          <div class="txt2">{{ pageData.desc2 }}</div>
          <div class="txt3"><span>支持星球人数：</span>{{ pageData.desc }}</div>
        </div>
        <div class="div-con" v-else>
          <img :src="pageData.bg_img_path" class="img-bg" alt="" >
          <span class="bg-title">{{ pageData.title }}</span>
          <div class="txt1"><span class="desc">{{ pageData.desc1 }}</span></div>
          <div class="txt2">{{ pageData.desc2 }}</div>
        </div>
        <div class="flex-nav3" v-if="details[curItem] && details[curItem].key === 'xinqiu'">
          <div class="nav3-txt" :class="curItem5 === index + '' ? 'cur' : ''" v-for="(item, index) in details[curItem].lists"
            :key="index" @click="handleClickItem5(index)">{{ item.title }}</div>
        </div>
        <div class="flex-div" v-if="Object.keys(couponInfoObj) && Object.keys(couponInfoObj).length > 0">
          <div class="title">超值订阅包</div>
          <div class="gift-div">
            <div class="gift-top" v-if="Object.keys(couponInfoObj) && Object.keys(couponInfoObj).length > 0">
              <div class="top-con" v-if="couponInfoObj.has_info && Object.keys(couponInfoObj.has_info).length > 0">
                <div class="gift-txt4">优惠劵倒计时 <van-count-down :time="couponTime2" format="HH:mm:ss"></van-count-down></div>
              </div>
              <div class="top-con" v-else>
                <div class="gift-txt1">大额优惠劵，立享优惠</div>
                <div class="gift-btn1" @click="isCoupon = true">立即抢</div>
              </div>
            </div>
            <div class="gift-top" v-else>
              <div class="top-con">
                <div class="gift-txt1">暂无优惠</div>
              </div>
            </div>
            <div class="gift-con">
              <div class="gift-con-left" v-if="details[curItem] && details[curItem].key === 'join'">
                <div class="gift-txt2" style="margin-bottom: 0;">特惠价</div>
              </div>
              <div class="gift-con-left" v-else>
                <div class="gift-txt2" >一年会员</div>
                <div class="gift-txt3">特惠价</div>
              </div>
              <div class="gift-con-right" v-if="couponInfoObj.has_info && Object.keys(couponInfoObj.has_info).length > 0">
                <div class="right-txt1">已减{{ couponInfoObj.price }}元</div>
                <div class="right-txt2">{{ Number(pageData.price ? pageData.price - couponInfoObj.price : 0).toFixed(0) }}
                </div>
              </div>
              <div class="gift-con-right" v-else>
                <div class="right-txt2">{{ Number(pageData.price ? pageData.price : 0).toFixed(0) }}</div>
              </div>
            </div>
          </div>
          <div class="coupon-deduct-div" @click="isCouponList = true">
            <img src="@/assets/images_member/20240302/quan.png" class="coupon-deduct-icon" alt="">
            <div class="coupon-deduct-txt">优惠劵抵扣</div>
            <div class="div-right div-right-cur"
              v-if="couponInfoObj.has_info && Object.keys(couponInfoObj.has_info).length > 0">
              优惠￥{{ couponInfoObj.price }}
              <img src="@/assets/images_member/20231018/img(5).png" class="icon-right" alt="">
            </div>
            <div class="div-right" v-else>
              暂无可用
              <img src="@/assets/images_member/20231018/img(5).png" class="icon-right" alt="">
            </div>
          </div>
        </div>
        <div class="block-div">
          <div class="div-title status">支付方式</div>
          <van-radio-group v-model="radio">
            <van-cell-group>
              <van-cell clickable @click="radio = '1'" v-if="couponInfoObj.has_info ? (pageData.price - couponInfoObj.has_info.price) < 3000 : pageData.price < 3000">
                <div class="cell-left">
                  <img src="@/assets/images_member/20240302/Group 1345.png" class="icon-cell" alt="">
                  <div class="div-cell">微信支付</div>
                </div>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              <van-cell clickable @click="radio = '2'">
                <div class="cell-left yue-cell">
                  <img src="@/assets/images_member/20240302/Group 1346.png" class="icon-cell" alt="">
                  <div class="div-cell">
                    <div class="cell-txt">余额支付(¥{{ userInfo.rec_money }})</div>
                    <div class="cell-recharge">
                      余额不足，<span class="recharge-btn" @click="handleJump('RECHARGE')">点击充值</span>
                    </div>
                  </div>
                </div>
                <template #right-icon>
                  <van-radio name="2" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
        <div class="block-div" v-if="pageData.id==7">
          <div class="div-title status">礼包接收地址</div>
          <div class="block-libao-div">
            <div class="div-input">
              <span>* 收件人：</span><input type="text" placeholder="请输入收件人名称" v-model="delivery_name" class="input-txt">
            </div>
            <div class="div-input">
              <span>* 收件人电话：</span><input type="text" placeholder="请输入收件人电话" v-model="delivery_mobile" class="input-txt">
            </div>
            <div class="div-input">
              <span>* 收件人地址：</span><input type="text" placeholder="请输入收件人地址" v-model="delivery_address" class="input-txt">
            </div>
          </div>
        </div>
      </div>
      <div class="block-div block-div2" v-if="details[curItem] && details[curItem].key === 'join'">
        <div class="div-title">{{ details[curItem] ? details[curItem].title : '' }}尊享特权</div>
        <div class="div-txt">{{ pageData.link_card_lists.length }}大联合年卡 价值<span>{{ pageData.all_price }}</span>元</div>
        <div class="div-flex-card">
          <div class="item-card" v-for="(item, index) in pageData.link_card_lists" :key="index">
            <img :src="item.cover_path" class="item-card-cover" alt="">
            <div class="item-card-txt">
              <div class="txt1">{{ item.title }}</div>
              <div class="txt2">
                价值:
                <span class="price-txt">¥{{ Number(item.price).toFixed(0) }}</span>
              </div>
            </div>
          </div>
        </div>
        <img :src="pageData.content_img_path" class="info-img" alt="">
      </div>
      <div class="block-div block-div2" v-else>
        <div class="div-title">{{ details[curItem] ? details[curItem].title : '' }}特权</div>
        <img :src="pageData.content_img_path" class="info-img" alt="">
      </div>
      <div class="fixed-btn">
        <div class="btn-txt" :class="checked ? 'cur' : ''" @click="handleSure">支付首礼劵 ¥{{ couponInfoObj.has_info ?
          pageData.price - couponInfoObj.has_info.price :
          pageData.price }}</div>
        <div class="fixed-txt">
          <img src="@/assets/images_member/20230719/icon (1).png" v-if="!checked" @click="checked = !checked"
            class="img-check" alt="">
          <img src="@/assets/images_member/20230719/Group 288@2x.png" v-else @click="checked = !checked" class="img-check"
            alt="">
          <div>
            支付即表示您同意
            <span class="txt" @click="checkedFalse = true;">《分销联盟会员服务协议》、</span>
            <span class="txt" @click="checkedFalse2 = true;">《分销联盟佣金与行为规则》</span>
          </div>
        </div>
      </div>
      <van-overlay :show="show" @click="show = false; checkedFalse = true">
        <div class="wrapper" @click.stop>
          <span class="wrapper-title">{{ dialogData.card_title }}</span>
          <img src="@/assets/images_member/Rectangle 2@2x.png" class="img1" alt="">
          <img src="@/assets/images_member/img12.png" class="img2" alt="">
          <div class="wrapper-con">
            <div class="txt1">{{ dialogData.title }}</div>
            <div class="txt2">{{ dialogData.content }}</div>
            <div class="btn1" @click="show = false; checkedFalse = true">我知道了</div>
          </div>
        </div>
      </van-overlay>
      <div class="dialog-block" v-if="checkedFalse" @click="checkedFalse = false">
        <div class="dialog-bg" @click="checkedFalse2 = false"></div>
        <div class="xieyi" @click.stop>
          <span class="xieyi-title">{{ detailsConten.title }}</span>
          <div class="xieyi-con" v-html="checkConten">
          </div>
          <div class="xieyi-btn" @click="checkedFalse = false; checked = true">
            <div class="xieyi-txt">同意协议并继续</div>
          </div>
        </div>
      </div>
      <div class="dialog-block" v-if="checkedFalse2" @click="checkedFalse2 = false">
        <div class="dialog-bg" @click="checkedFalse2 = false"></div>
        <div class="xieyi" @click.stop>
          <span class="xieyi-title">{{ detailsConten2.title }}</span>
          <div class="xieyi-con" v-html="checkConten2"></div>
          <div class="xieyi-btn" @click="checkedFalse2 = false; checked = true">
            <div class="xieyi-txt">同意协议并继续</div>
          </div>
        </div>
      </div>
      <!-- <van-overlay :show="showCoupon">
        <div class="wrapper-coupon" @click.stop>
          <div class="wrapper-con">
            <img src="@/assets/images_member/20230804/image 116@2x.png" class="con-coupon-img1" alt="">
            <div class="coupon-div">
              <img src="@/assets/images_member/20230804/Group 848@2x.png" class="con-coupon-img2" alt="">
              <img src="@/assets/images_member/20230804/Group 847@2x.png" class="con-coupon-img3" alt="">
              <div class="con-coupon-txt1">领取后开始倒计时</div>
              <div class="con-coupon-btn1" @click="handleGetCoupon">立即领取</div>
            </div>
          </div>
        </div>
      </van-overlay> -->
      <van-overlay :show="isCoupon" @click="isCoupon = false">
        <div class="van-coupon-block" @click.stop>
          <img src="@/assets/images_member/20240302/Group 1356.png" class="coupon-tip-img" @click="handleGetCoupon2" alt="">
          <div class="title">开通全域达人，福利发放中</div>
          <div class="price-txt"><span>￥</span>{{ Number(couponInfoObj.price).toFixed(0) }}</div>
          <div class="vip-txt">
            {{ details[curItem] && details[curItem].key === 'xinqiu' ? details[curItem].title:''}}{{ pageData.title }}专用</div>
        </div>
      </van-overlay>
      <van-overlay :show="isCouponList" @click="isCouponList = false">
        <div class="overlay-coupon-list">
          <div class="overlay-coupon-top">
            <div class="overlay-txt1">选择优惠劵</div>
            <img src="@/assets/images_member/20231018/img(11).png" class="icon-close" alt="">
          </div>
          <div class="overlay-coupon-con" v-if="couponInfoObj.has_info && Object.keys(couponInfoObj.has_info).length > 0">
            <div class="overlay-coupon-block">
              <div class="overlay-coupon-flex">
                <div class="overlay-coupon-left">
                  <div class="overlay-txt2">{{ details[curItem] ? details[curItem].title : '' }}{{ couponInfoObj.web_title
                  }}优惠劵</div>
                  <div class="overlay-txt3">{{ couponInfoObj.has_info.end_time }}到期</div>
                </div>
                <div class="overlay-coupon-left2">
                  <div class="overlay-txt5">{{ Number(couponInfoObj.price).toFixed(0) }}</div>
                  <div class="overlay-txt6">限角色使用｜年会员</div>
                </div>
                <img src="@/assets/images_member/20231018/img(12).png" class="icon-check" alt="">
              </div>
              <div class="overlay-txt4">限:开通{{ details[curItem] ? details[curItem].title : '' }}{{ couponInfoObj.web_title
              }}可使用。</div>
            </div>
            <div class="overlay-submit-btn">确认</div>
          </div>
          <div class="overlay-coupon-none" v-else>
            <img src="@/assets/images_member/20231018/img(14).png" class="none-img" alt="">
            <div class="none-txt">暂无可用优惠劵哦～</div>
            <div class="none-btn" @click="handleJump('couponlist')">查看我的优惠劵</div>
          </div>
        </div>
      </van-overlay>
      <div class="dialog-block" v-if="payCheck" @click="payCheck = false">
        <div class="dialog-bg" @click="payCheck = false"></div>
        <div class="tanchuang" @click.stop>
          <img src="@/assets/images_member/20240302/Mask group.png" class="tanchuang-mask">
          <div class="tips flex"><div class="sy">购买的套餐：</div><div class="sy2">{{ details[curItem] && details[curItem].key === 'xinqiu' ? details[curItem].title:''}}{{ pageData.title }}</div></div>
          <div class="tips flex"><div class="sy">套餐价格：</div><div class="sy2">¥{{pageData.price}}</div></div>
          <div class="tips flex" v-if="couponInfoObj.has_info"><div class="sy">优惠券抵扣：</div><div class="sy2">¥{{ couponInfoObj.has_info.price }}</div></div>
          <div class="tips flex"><div class="sy">有效期至：</div><div class="sy2">{{pageData.end_time}}</div></div>
          <div class="tips flex"><div class="sy">支付方式：</div><div class="sy2">{{radio === '1' ? '微信支付' : '余额支付'}}</div></div>
          <div class="price"><div class="price_txt">合计：<span>￥{{ couponInfoObj.has_info ?
          pageData.price - couponInfoObj.has_info.price :
          pageData.price }}</span></div></div>
          <div class="pay-btn" @click="handlePayFun">立即支付</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { viplists, addOrder, hasEndTip, getSigelInfo, cards, getVipIdCoupon, postVipIdCoupon } from '@/api/person'
import { handlePay } from '@/utils/wxConfig'
import { Toast } from 'vant'
export default {
  data () {
    return {
      time: 0,
      radio: '1',
      show: false,
      dialogData: {},
      details: [],
      curItem: '0',
      curItem2: '0',
      curItem3: '0',
      curItem4: '0',
      curItem5: '0',
      curItem6: '0',
      checked: false,
      checkedFalse: false,
      checkedFalse2: false,
      payCheck: false,
      checkConten: '',
      checkConten2: '',
      detailsConten: {},
      detailsConten2: {},
      showCoupon: false,
      couponTime: 0,
      showCountTime: false,
      click: false,
      isCoupon: false,
      isCouponList: false,
      couponInfoCon: [],
      couponInfoObj: {},
      delivery_name: '',
      delivery_mobile: '',
      delivery_address: '',
      paySure: true,
    }
  },
  computed: {
    userInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_user-info']).value
    },
    thirdUserInfo () {
      return JSON.parse(this.$ls.storage['xingfugongshe_third-user-info']).value
    },
    pageData () {
      // 判断当前选中的是哪个，然后取下面的内容
      if (this.details[this.curItem] && this.details[this.curItem].key === 'dodo') {
        return this.details[this.curItem] && this.details[this.curItem].lists[0]
          ? this.details[this.curItem] && this.details[this.curItem].lists[0] : {}
      } else if (this.details[this.curItem] && this.details[this.curItem].key === 'join') {
        return this.details[this.curItem] && this.details[this.curItem].lists[this.curItem2]
          ? this.details[this.curItem] && this.details[this.curItem].lists[this.curItem2] : {}
      } else if (this.details[this.curItem] && this.details[this.curItem].key === 'ecology') {
        return this.details[this.curItem] && this.details[this.curItem].lists[this.curItem3].lists[this.curItem4]
          ? this.details[this.curItem] && this.details[this.curItem].lists[this.curItem3].lists[this.curItem4] : {}
      } else if (this.details[this.curItem] && this.details[this.curItem].key === 'xinqiu') {
        return this.details[this.curItem] && this.details[this.curItem].lists[this.curItem5].lists[this.curItem6]
          ? this.details[this.curItem] && this.details[this.curItem].lists[this.curItem5].lists[this.curItem6] : {}
      } else {
        return {}
      }
    },
    couponTime2 () {
      let times = 0
      if (this.couponInfoObj.has_info && Object.keys(this.couponInfoObj.has_info).length > 0) {
        times = new Date(this.couponInfoObj.has_info.end_time).getTime() - new Date().getTime()
      }
      return times
    }
  },
  watch: {
    pageData (newval, old) {
      if (newval.price > 3000) {
        this.radio = '2'
      } else {
        this.radio = '1'
      }
    }
  },
  created () {
    this.handleFunc()
    getSigelInfo({ id: 2 }).then(res => {
      this.checkConten = res.data.content
      this.detailsConten = res.data
    })
    getSigelInfo({ id: 3 }).then(res => {
      this.checkConten2 = res.data.content
      this.detailsConten2 = res.data
    })
    cards().then(res => {
      let curtime = new Date(new Date().toISOString().slice(0, 10)).getTime() // 获取当前时间的日期
      let localtime = new Date(new Date(Number(localStorage.getItem('couponTime'))).toISOString().slice(0, 10)).getTime() // 获取存储本地时间的日期
      if (localtime - curtime >= 24 * 60 * 60 * 1000) {
        localStorage.removeItem('couponTime')
      }
      this.cardList = res.data
      this.showCountTime = !((this.cardList.length <= 0 && !localStorage.getItem('couponTime')))
      this.showCoupon = (this.cardList.length <= 0 && !localStorage.getItem('couponTime'))
      this.couponTime = localStorage.getItem('couponTime') ? localStorage.getItem('couponTime') - new Date().getTime() : 0
    })
  },
  methods: {
    handleFun () {
      getVipIdCoupon().then(res => {
        this.couponInfoCon = res.data
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      })
      if (this.$route.query.column === '1') {
        this.curItem = '1'
      }
    },
    // 第二版的获取优惠券
    handleGetCoupon2 () {
      postVipIdCoupon({
        coupon_id: this.couponInfoObj.id
      }).then(res => {
        this.$toast(res.msg)
        this.isCoupon = false
        if (res.code === 1) {
          this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
          console.log(this.couponInfoObj)
          this.handleFun()
        }
      })
    },
    // 点击获取优惠券
    handleGetCoupon () {
      if (localStorage.getItem('couponTime')) return
      let curHours = new Date().getHours()
      let couponTime = 0
      if ((23 - curHours) > 6) {
        couponTime = new Date().getTime() + 6 * 60 * 60 * 1000
      } else {
        let year = new Date().getFullYear()
        let month = new Date().getMonth() + 1
        let day = new Date().getDate()
        couponTime = new Date(`${year}-${month}-${day} 23:59:59`).getTime()
      }
      this.couponTime = couponTime - new Date().getTime()
      this.showCountTime = true
      localStorage.setItem('couponTime', couponTime)
      this.showCoupon = false
    },
    handleClickItem (index) {
      console.log(this.couponInfoCon)
      console.log(this.pageData.id)
      this.curItem = index + ''
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
      console.log(this.couponInfoObj)
    },
    handleClickItem2 (index) {
      this.curItem2 = index + ''
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
    },
    handleClickItem3 (index) {
      this.curItem3 = index + ''
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
    },
    handleClickItem4 (index) {
      this.curItem4 = index + ''
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
    },
    handleClickItem5 (index) {
      this.curItem5 = index + ''
      console.log(this.couponInfoCon)
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
    },
    handleClickItem6 (index) {
      this.curItem6 = index + ''
      if (this.couponInfoCon[this.pageData.id].coupon_info) {
        this.couponInfoObj = this.couponInfoCon[this.pageData.id].coupon_info
      } else {
        this.couponInfoObj = {}
      }
    },

    handleFunc () {
      viplists().then(res => {
        this.details = res.data
        if (this.$route.query.curItem) {
          this.curItem = this.$route.query.curItem
        }
        if (this.$route.query.curItem2) {
          this.curItem2 = this.$route.query.curItem2
        }
        if (this.$route.query.curItem3) {
          this.curItem3 = this.$route.query.curItem3
        }
        if (this.$route.query.curItem4) {
          this.curItem4 = this.$route.query.curItem4
        }
        this.handleFun()
      }).catch(err => {
        console.log(err)
      })
      hasEndTip().then(res => {
        let bool = false
        if (!localStorage.getItem('time')) {
          localStorage.setItem('time', new Date().getTime() + 1 * 60 * 60 * 1000)
          bool = true
        } else {
          let oldTime = localStorage.getItem('time')
          bool = new Date().getTime() - new Date(oldTime).getTime() > 0
        }
        if (res.data.length > 0 && bool) {
          this.show = true
          this.dialogData = res.data[0]
        } else if (res.data.length > 0 && !this.checked) {
          this.checkedFalse = true
        }
      })
    },
    handleJump (type) {
      let url = ''
      switch (type) {
        case 'RECHARGE':
          url = '/recharge'
          break

        case 'PAGECARD':
          url = '/pageCard'
          break

        case 'couponlist':
          url = '/coupon'
          break

        case 'INDEX':
          url = '/'
          break

        default:
          break
      }
      this.$router.push({
        path: url
      })
    },
    handleSure () {
      if (this.pageData.id === 7) {
        if (this.delivery_name === '') {
          this.$toast('请输入收件人名称')
          return
        }
        if (this.delivery_mobile === '') {
          this.$toast('请输入收件人电话')
          return
        }
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/
        if (!reg.test(this.delivery_mobile)) {
          this.$toast('请输入正确的收件人电话')
          return
        }
        if (this.delivery_address === '') {
          this.$toast('请输入收件人地址')
          return
        }
      }
      if (!this.checked) return
      var ua = navigator.userAgent.toLowerCase()
      var weixin = ua.indexOf('micromessenger') !== -1
      console.log(weixin)
      if (this.radio === '1' && !weixin) {
        console.log('666')
        this.$toast('请到微信公众号“幸福公社”去支付，否则请用余额支付')
        return false
      }
      this.payCheck = true
    },
    handlePayFun () {
      if (!this.paySure) return
      this.paySure = false
      Toast('支付中...')
      let params = {
        id: this.pageData.id,
        pay_type: this.radio === '1' ? 'adapay' : 'balance',
      }
      if (this.couponInfoObj.has_info) {
        params.coupon_id = this.couponInfoObj.has_info.id
      }
      if (this.radio === '1') {
        params.openid = this.thirdUserInfo.openid
        params.toPage = `${process.env.viewURL}/paySuccess`
      }
      if (this.pageData.id === 7) {
        params.delivery_name = this.delivery_name
        params.delivery_mobile = this.delivery_mobile
        params.delivery_address = this.delivery_address
      }
      addOrder(params).then(res => {
        this.paySure = true
        if (res.code !== 1) {
          Toast(res.msg)
          return
        } else {
          setTimeout(() => {
            this.click = false
          }, 500)
          localStorage.setItem('menberOrder', JSON.stringify(res.data))
          if (this.radio === '1') {
            handlePay(res)
            return
          }
        }
        this.$router.push({
          path: '/paySuccess'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tanchuang{
  background: #FFFBFB;
  border-radius: 10px;
  top:0;
  position: relative;
  z-index: 100;
  width: 250px;
  top: 50%;
  left: 62.5px;
  transform: translateY(-50%);
  padding-bottom: 15px;
  .tanchuang-mask{
    width:100%;
  }
  .tips{
    display:flex;
    padding: 0 15px;
    font-size: 12px;
    height:35px;
    line-height: 35px;
    .sy{
      color: #5C5C5C;
    }
    .sy2{
      margin-left: auto;
      text-align: right;
      color:#1E0606;
      font-weight: 600;
    }
    &:nth-child(2n){
      background: #F4F2F2;
    }
  }
  .price{
    margin-top: 10px;
    display:flex;
    padding: 0 15px;
    .price_txt{
      font-size: 12.5px;
      margin-left: auto;
      color:#5C5C5C;
      span{
        font-size: 14px;
        color: #DE0000;
      }
    }
  }
  .pay-btn{
    margin:7.5px auto 0;
    width:181px;
    height:38px;
    line-height: 38px;
    text-align: center;
    background: linear-gradient(90deg, #FC5643 9.61%, #EF6807 84.46%);
    color: #FFFFFF;
    border-radius: 30px;
  }
}
.block-libao-div{
  .div-input {
    // line-height: 60px;
    display: flex;
    align-items: center;
    font-size: 13px;
    margin:10px 0;
    height:35px;
    color:#FFFFFF;
    span{
      width:100px;
    }
    .input-txt {
      padding:0 15px;
      height: 35px;
      font-size: 13px;
      outline: none;
      border: none;
      background-color: transparent;
      flex: 1;
      color: #000;
      background: #fff;
      border:1px solid #F4CA87;
      border-radius: 30px;
      &::placeholder {
        font-size: #999999;
      }
    }

    .get-code {
      color: #504632;
      font-size: 14px;
      text-align: center;
      line-height: 38px;
      font-weight: 500;
      width: 102px;
      border-radius: 100px;
      background-color: #F0E1C0;
      height: 38px;
    }
  }
}
.open-menber {
  min-height: 100vh;
  padding-bottom: 130px;
  box-sizing: border-box;
  overflow-x: hidden;
  .head{
    img{
      width:100%;
      height:auto;
    }
  }
  .index{
    width: 95vw;
    margin:-155px auto 0;
  }
  .open-menber-bg{
    position: relative;
    z-index: 2;
    padding-bottom: 20px;
    border-radius: 10px;
    background-color: #242424;
  }
  .agency-per {
    position: relative;
    display: flex;
    padding: 20px 14px;
    align-items: center;
    box-sizing: border-box;

    .per-head {
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border-radius: 50%;
    }

    .per-con {
      display: flex;
      flex-direction: column;

      .name {
        font-size: 16px;
        color: #F0E1C0;
        font-weight: 500;
        line-height: 16px;
        margin-bottom: 6px;
      }

      .tag {
        text-align: center;
        color: #E3C58C;
        font-size: 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-items: center;
        .icon {
          width: 15px;
          height: 15px;
          margin-left: 6px;
          display: block;
        }
      }
    }
  }

  .card-bag {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 26px;
    width: 100px;
    border-radius: 100px;
    border: 1px solid #9C8E78;
    background: linear-gradient(180deg, rgba(116, 111, 105, 0.24) 0%, rgba(32, 26, 21, 0.24) 100%);
    position: absolute;
    top: 27px;
    right: 14px;

    .icon-bag {
      width: 14px;
      height: 17px;
      display: block;
      margin-right: 4px;
    }

    .txt {
      font-size: 12px;
      color: #F7D092;
      line-height: 16px;
    }
  }

  .flex-nav {
    display: flex;
    align-items: center;
    padding-left: 14px;
    box-sizing: border-box;
    margin-top: 10px;

    .nav-txt {
      font-size: 16px;
      color: #CCCCCC;
      margin-right: 30px;
      position: relative;

      &.cur {
        color: #F0E1C0;
        font-weight: 600;
        font-size: 18px;

        &::after {
          position: absolute;
          bottom: -10px;
          left: 0;
          background-color: #F0E1C0;
          width: 34px;
          height: 2px;
          content: "";
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }

  .flex-nav2 {
    display: flex;
    align-items: center;
    padding: 0 14px;
    margin-top: 32px;

    .nav2-txt {
      width: 68px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      border-radius: 100px;
      background-color: #2F3131;
      color: #fff;
      font-size: 12px;
      margin-right: 10px;
      padding: 0 5px;

      &.cur {
        background-color: #F0E1C0;
        color: #504632;
        font-weight: bold;
      }
    }
  }

  .flex-nav3 {
    display: flex;
    align-items: center;
    margin-top: 16px;
    height: 44px;
    padding-left: 20px;
    justify-content: center;
    .nav3-txt {
      margin-right: 20px;
      color: #DDB164;
      font-size: 14px;
      background: #242424;
      padding: 5px 26px;
      border-radius: 100px;
      border:1px solid #DDB164;
      &.cur {
        font-weight: 600;
        color: #000000;
        background: linear-gradient(90.07deg, #F9DEB0 4.99%, #D3A14B 99.93%);
      }
    }
  }

  .flex-nav4 {
    margin-top: 17px;
    display: flex;
    align-items: center;
    height: 52px;
    padding-left: 14px;
    box-sizing: border-box;
    .nav4-txt {
      width: 68px;
      height: 28px;
      line-height: 28px;
      text-align: center;
      margin-right: 10px;
      border-radius: 100px;
      font-size: 12px;
      color: #F7E0CF;
      background-color: #423D42;
      &.cur {
        background-color: #E8CC96;
        color: #000000;
        font-weight: bold;
      }
    }
  }

  .div-con {
    width: 100%;
    height: 132px;
    position: relative;
    margin-top: 26px;

    .img-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 8px;
      box-sizing: border-box;
    }

    .bg-title {
      font-weight: 600;
      font-size: 13px;
      color: #442901;
      line-height: 12px;
      position: absolute;
      top: 17px;
      left: 130px;
    }

    .txt1 {
      position: relative;
      font-size: 28px;
      font-family: YouSheBiaoTiHei;
      color: #442901;
      line-height: 20px;
      top: 58px;
      left: 28px;
    }

    .txt2 {
      color: #56200B;
      font-size: 12px;
      position: relative;
      top: 80px;
      left: 28px;
    }
  }
  .div-con-xinqiu{
    width: 100%;
    height: 174px;
    position: relative;
    margin-top: 10px;
    .img-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      // padding: 0 8px;
      box-sizing: border-box;
    }

    .bg-title {
      font-weight: 600;
      font-size: 13px;
      color: #442901;
      line-height: 12px;
      position: absolute;
      top: 18px;
      left: 120px;
    }

    .txt1 {
      position: relative;
      font-size: 28px;
      font-family: YouSheBiaoTiHei;
      color: #442901;
      line-height: 20px;
      top: 50px;
      left: 28px;
      display: flex;
      align-items: center;
      justify-items: center;
      .x{
        display: block;
        width:3px;
        height: 3px;
        border-radius: 100%;
        background: #001939;
        margin:0 7.5px 0 3.5px;
      }
      .desc{
        font-size: 13px;
        font-weight: 600;
        line-height: 36px;
        letter-spacing: 0px;
        text-align: left;

      }
    }

    .txt2 {
      color: #001939;
      font-size: 12px;
      position: relative;
      top: 70px;
      left: 28px;
    }
    .txt3 {
      color: #001939;
      font-size: 12px;
      position: relative;
      top: 85px;
      left: 28px;
      font-size: 18px;
      display: flex;
      align-items: center;
      justify-items: center;
      line-height: 30px;
      span{
        font-size: 12px;
      }
    }
  }
  .flex-div {
    padding: 0 14px;
    box-sizing: border-box;

    .title {
      font-size: 16px;
      color: #FFFFFF;
      font-weight: 500;
      margin-top: 20px;
      margin-bottom: 14px;
    }

    .gift-div {
      border-radius: 10px;
      overflow: hidden;
      width: 100%;
      position: relative;

      .gift-top {
        background: linear-gradient(98deg, #EE793B 0%, #E42E1B 100%);
        width: 100%;
        height: 80px;

        .top-con {
          height: 52px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          padding: 0 14px;
          box-sizing: border-box;

          .gift-txt1 {
            font-size: 16px;
            font-weight: 600;
            color: #FFFFFF;
          }

          .gift-txt4 {
            font-size: 20px;
            color: #fff;
            font-weight: 600;
            justify-content: center;
            flex: 1;
            display: flex;
            align-items: center;
            height: 52px;

            /deep/ .van-count-down {
              font-size: 20px;
              color: #fff;
              font-weight: 600;
              height: 52px;
              line-height: 52px;
              margin-left: 6px;
            }
          }

          .gift-btn1 {
            width: 88px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            border-radius: 100px;
            background-color: #fff;
            font-size: 16px;
            font-weight: 600;
            color: #FF512F;
          }
        }
      }

      .gift-con {
        display: flex;
        justify-content: space-between;
        background-color: #fff;
        margin-top: -28px;
        border-radius:0 0 10px 10px;
        overflow: hidden;
        height: 80px;
        align-items: center;
        padding: 0 14px;
        box-sizing: border-box;

        .gift-con-left {
          .gift-txt2 {
            font-size: 18px;
            line-height: 18px;
            color: #504632;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .gift-txt3 {
            font-size: 14px;
            color: #9C8A64;
            font-weight: 500;
          }
        }

        .gift-con-right {
          font-size: 34px;
          color: #504632;
          font-weight: 600;
          position: relative;
          text-align: right;

          .right-txt1 {
            height: 18px;
            color: #fff;
            text-align: center;
            line-height: 18px;
            font-size: 12px;
            font-weight: 500;
            border-radius: 100px 100px 100px 0;
            overflow: hidden;
            background: linear-gradient(270deg, #FF621F 0%, #FAA72A 100%);
            margin-bottom: 2px;
            padding: 0 8px;
          }

          .right-txt2 {
            display: inline-block;
            position: relative;

            &::before {
              content: '￥';
              color: #504632;
              font-size: 16px;
              position: absolute;
              left: -16px;
              font-weight: bold;
              bottom: 6px;
            }
          }
        }
      }
    }

    .coupon-deduct-div {
      display: flex;
      align-items: center;
      height: 60px;
      border-radius: 10px;
      overflow: hidden;
      border: 1px solid #9C8E78;
      margin-top: 14px;
      padding: 0 14px;
      box-sizing: border-box;

      .coupon-deduct-icon {
        width: 28px;
        height: 28px;
        margin-right: 8px;
        display: block;
      }

      .coupon-deduct-txt {
        font-size: 16px;
        color: #FFFFFF;
        font-weight: 600;
        flex: 1;
      }

      .div-right {
        display: flex;
        align-items: center;
        font-size: 16px;
        color: #fff;

        &.div-right-cur {
          color: #E3BF82;
        }
        .icon-right {
          width: 8px;
          display: block;
          margin-left: 6px;
        }
      }
    }

  }

  .block-div {
    border-radius: 10px;
    background-color: #2F3131;
    margin: 0 14px;
    margin-top: 14px;
    padding: 16px 14px;
    box-sizing: border-box;

    .div-title {
      font-size: 18px;
      color: #FFFFFF;
      box-sizing: border-box;
      font-weight: 500;

      &.status {
        font-size: 14px;
      }
    }

    .div-txt {
      width: 250px;
      border-radius: 100px;
      height: 32px;
      background-color: #464044;
      line-height: 34px;
      text-align: center;
      font-size: 12px;
      color: #FFEBD7;
      font-weight: 600;
      margin:15px auto 23px;
      display: flex;
      justify-content: center;
      span{
        background: linear-gradient(180deg, #FFF6D5 0%, #FED132 100%);
        -webkit-background-clip: text;/*将设置的背景颜色限制在文字中*/
        -webkit-text-fill-color: transparent;/*给文字设置成透明*/
        font-size: 24px;
        margin:0 5px;
      }
    }

    .div-flex-card {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .item-card {
        .item-card-cover {
          width: 58px;
          height: 58px;
          object-fit: cover;
          margin-bottom: 6px;
          border-radius: 50%;
          overflow: hidden;
          margin-left: 50%;
          transform: translateX(-50%);
        }

        .item-card-txt {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .txt1 {
            font-size: 12px;
            line-height: 12px;
            margin-bottom: 6px;
            color: #EFCCA3;
          }

          .txt2 {
            display: flex;
            font-size: 11px;
            color: #EFCCA3;
            align-items: center;

            .price-txt {
              font-size: 14px;
              color: #EAB143;
              margin-left: 2px;
            }
          }
        }
      }
    }

    .info-img {
      width: 100%;
      display: block;
      margin-top: 14px;
    }

    /deep/ .van-radio-group {
      .van-cell-group,
      .van-cell {
        background-color: transparent;
        padding: 0;
        margin-top: 24px;
        align-items: flex-start;

        &::after {
          border: none;
        }
      }
      .van-radio__icon{
        .van-icon{
          border:1px solid #E3BF82;
        }
      }
      .van-radio__icon--checked {
        .van-icon {
          background: #F4CA87;
          border-color: #F4CA87;
          color: #2F3131;
        }
      }

      .cell-left {
        display: flex;
        align-items: center;

        &.yue-cell {
          align-items: flex-start;
        }

        .icon-cell {
          width: 40px;
          height: 40px;
          margin-right: 8px;
        }

        .div-cell {
          font-size: 14px;
          color: #FFFFFF;
          font-weight: 500;
          display: flex;
          flex-direction: column;

          .cell-txt {
            font-size: 14px;
            color: #FFFFFF;
            // margin-bottom: 6px;
          }

          .cell-recharge {
            color: rgb(172, 170, 169);

            .recharge-btn {
              color:#E3BF82;
              text-decoration: underline;
            }
          }
        }
      }
    }

    .div-payment {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 16px;
      margin-top: 18px;

      .payment-label {
        font-size: 14px;
        color: #CCCCCC;
        font-weight: 500;
      }

      .payment-val {
        font-size: 16px;
        color: #F0E1C0;
        font-weight: bold;
      }
    }

  }
  .block-div2{
    background-color: #1F212D;
    margin: 14px 0 0;
    padding:0 0 16px;
    overflow: hidden;
    .div-title{
      background: linear-gradient(146.67deg, #EED6A5 13.54%, #DBAF6A 82.55%);
      // border-radius: 10px 12px 0 0;
      padding:0 17.5px;
      height: 42px;
      line-height: 42px;
    }
    .div-flex-card{
      padding:0 17.5px;
    }
  }
  .fixed-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 121px;
    justify-content: space-between;
    background-color: #1F212D;
    align-items: center;
    display: flex;
    padding: 10px 14px 17px;
    box-sizing: border-box;
    flex-direction: column;
    z-index: 999;

    .fixed-txt {
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      display: flex;

      .img-check {
        width: 13px;
        height: 13px;
        margin-right: 10px;
      }

      .txt {
        color: #F6D487;
        display: inline-block;
      }
    }

    .btn-txt {
      width: 347px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      height: 48px;
      display: block;
      border-radius: 100px;
      font-size: 18px;
      font-weight: 600;
      background-color: #6C685E;
      color: #504632;

      &.cur {
        background-color: #F0E1C0;
        color: #504632;
      }
    }
  }

  .wrapper {
    position: relative;
    width: 300px;
    left: 38px;
    top: 138px;

    .wrapper-title {
      color: #fff;
      position: absolute;
      top: 14px;
      font-size: 12px;
      left: 104px
    }

    .img1 {
      width: 280px;
      height: auto;
    }

    .img2 {
      width: 111px;
      height: 67px;
      right: -22px;
      top: -7px;
      position: absolute;
    }

    .wrapper-con {
      width: 300px;
      height: 292px;
      background-color: #2F3131;
      border-radius: 20px;
      position: relative;
      margin-top: -65px;

      .txt1 {
        text-align: center;
        font-size: 24px;
        line-height: 24px;
        color: #F0E1C0;
        font-weight: bold;
        margin-bottom: 40px;
        padding-top: 40px;
        box-sizing: border-box;
      }

      .txt2 {
        line-height: 30px;
        font-size: 18px;
        color: #F1F2F9;
        width: 240px;
        margin-left: 30px;
        margin-bottom: 40px;
      }

      .btn1 {
        width: 240px;
        height: 48px;
        text-align: center;
        line-height: 48px;
        font-size: 18px;
        color: #504632;
        font-weight: 600;
        border-radius: 100px;
        margin-left: 30px;
        background: linear-gradient(109deg, #FFECD0 0%, #FFC387 100%);
      }
    }
  }

  .xieyi {
    background-color: #2F3131;
    border-radius: 10px;
    width: 320px;
    left: 28px;
    height: 420px;
    position: relative;
    color: #fff;
    top: 93px;

    .xieyi-title {
      text-align: center;
      font-size: 18px;
      color: #FFFFFF;
      font-weight: 600;
      width: 100%;
      display: block;
      padding-top: 27px;
      padding-bottom: 20px;
      box-sizing: border-box;
    }

    .xieyi-con {
      padding: 0 16px;
      box-sizing: border-box;
      overflow-y: auto;
      height: 290px;
      line-height: 24px;
      font-size: 14px;
      color: #ccc;
      background: transparent;

      /deep/ p,
      /deep/ span {
        background: transparent !important;
        color: #ccc !important;
        font-size: 14px !important;
      }
    }

    .xieyi-btn {
      width: 100%;
      height: 64px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 0;
      left: 0;

      .xieyi-txt {
        border-radius: 100px;
        width: 280px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        background-color: #F0E1C0;
        color: #504632;
      }
    }
  }
}

.dialog-block {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;

  .dialog-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, .7);
  }

  .xieyi {
    position: absolute;
    z-index: 991;
  }
}

/deep/ .van-overlay {
  z-index: 999;

  .wrapper-coupon {
    width: 284px;
    position: absolute;
    top: 26px;
    left: 46px;

    .wrapper-con {
      width: 295px;
      border-radius: 10px;

      .con-coupon-img1 {
        width: 284px;
        display: block;
      }

      .coupon-div {
        background-color: #fff;
        padding-bottom: 24px;
        box-sizing: border-box;
        border-radius: 20px;

        .con-coupon-img2 {
          width: 295px;
          display: block;
        }

        .con-coupon-img3 {
          display: block;
          width: 223px;
          margin-left: 50%;
          transform: translateX(-50%);
          margin-top: 14px;
        }

        .con-coupon-txt1 {
          font-size: 12px;
          font-weight: 500;
          color: #EC634F;
          text-align: center;
          margin-top: 5px;
        }

        .con-coupon-btn1 {
          width: 240px;
          height: 54px;
          text-align: center;
          color: #F0E1C0;
          font-size: 18px;
          font-weight: 600;
          background: linear-gradient(98deg, #3E3E3E 0%, #3E3E3E 100%);
          line-height: 54px;
          border-radius: 100px;
          margin-left: 50%;
          transform: translateX(-50%);
          margin-top: 16px;
        }
      }
    }
  }
}

.van-coupon-block {
  position: relative;

  .coupon-tip-img {
    width: 100%;
    display: block;
  }

  .title{
    position: absolute;
    font-size: 13px;
    color: #440101;
    width:50%;
    left:25%;
    top: 110px;
    text-align: center;
  }
  .price-txt {
    position: absolute;
    font-size: 30px;
    color: #FFFFFF;
    top: 200px;
    left: 78px;
    width:100px;
    text-align: center;
    span{
      font-size: 12px;
      color: #fff;
    }
  }

  .vip-txt {
    position: absolute;
    color: #FFFFFF;
    font-size: 11px;
    font-weight: 600;
    left: 197px;
    top: 220px;
  }
}

.overlay-coupon-list {
  position: absolute;
  width: 100%;
  height: 310px;
  background-color: #2F3131;
  left: 0;
  bottom: 0;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;

  .overlay-coupon-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 58px;

    .overlay-txt1 {
      color: #FFFFFF;
      font-size: 18px;
      font-weight: 500;
    }

    .icon-close {
      width: 16px;
      height: 16px;
      display: block;
    }
  }

  .overlay-coupon-block {
    background-color: #fff;
    border-radius: 10px;
    padding: 0 14px;
    box-sizing: border-box;

    .overlay-coupon-flex {
      display: flex;
      align-items: center;
      padding: 24px 0;
      box-sizing: border-box;

      .icon-check {
        width: 20px;
        height: 20px;
        display: block;
        margin-left: 10px;
      }

      .overlay-coupon-left {
        flex: 1;

        .overlay-txt2 {
          font-size: 20px;
          color: #212121;
          font-weight: bold;
          line-height: 20px;
          margin-bottom: 12px;
        }

        .overlay-txt3 {
          background-color: #F0E1C0;
          border-radius: 3px;
          height: 20px;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color: #504632;
          font-weight: 500;
          display: inline-block;
          padding: 0 5px;
        }
      }

      .overlay-coupon-left2 {
        .overlay-txt5 {
          font-size: 30px;
          color: #E63429;
          line-height: 30px;
          font-weight: 600;
          margin-bottom: 10px;
          text-align: right;
        }

        .overlay-txt6 {
          color: #504632;
          font-weight: 500;
          font-size: 12px;
          text-align: right;
        }
      }
    }

    .overlay-txt4 {
      color: #7A7A7A;
      font-size: 12px;
      height: 48px;
      line-height: 48px;
      box-sizing: border-box;
      background-image: url('../../assets/images_member/20231018/img(2).png');
      background-repeat: no-repeat;
      background-size: contain;
    }
  }

  .overlay-submit-btn {
    position: absolute;
    width: 347px;
    height: 48px;
    text-align: center;
    line-height: 48px;
    background-color: #F0E1C0;
    border-radius: 100px;
    font-size: 16px;
    color: #504632;
    font-weight: 600;
    left: 50%;
    transform: translateX(-50%);
    bottom: 6px;
  }

  .none-img {
    margin-left: 50%;
    transform: translateX(-50%);
    width: 118px;
    display: block;
    margin-top: 40px;
  }

  .none-txt {
    font-size: 16px;
    color: #999999;
    line-height: 16px;
    margin-top: 16px;
    text-align: center;
    margin-bottom: 20px;
  }

  .none-btn {
    margin-left: 50%;
    transform: translateX(-50%);
    width: 110px;
    height: 32px;
    text-align: center;
    line-height: 32px;
    background-color: #F0E1C0;
    border-radius: 100px;
    font-size: 12px;
    color: #313333;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/openMenber/index.vue